var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12789_64294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9805 17.5C19.9805 18.875 18.8555 20 17.4805 20H2.48047C1.10547 20 -0.0195312 18.875 -0.0195312 17.5V2.5C-0.0195312 1.125 1.10547 0 2.48047 0H17.4805C18.8555 0 19.9805 1.125 19.9805 2.5V17.5Z",
    fill: "#3C579E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7742 20V12.2169H7.99609V9.44141H10.7748V6.87953C10.7748 4.29562 12.3005 2.77344 14.6052 2.77344C15.7095 2.77344 16.6105 2.89156 16.8872 2.92828V5.83031L15.0319 5.82953C13.7784 5.82953 13.5439 6.45125 13.5439 7.32516V9.44141H16.7558L16.302 12.2169H13.5439V20H10.7742Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12789_64294"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.a5a79c56a087c877897a599a98da7c9a.svg";
export { ForwardRef as ReactComponent };